import axios from "./axios"

const UsersApi = () => {
	const getAllUsers = async () => {
		try {
			const response = await axios.get("/users")
			return response.data
		} catch (error) {
			console.error("Error fetching users:", error)
			throw error
		}
	}

	const createUser = async (user) => {
		try {
			const response = await axios.post("/users", user)

			return response.data
		} catch (error) {
			console.error("Error creating useuserrs:", error)
			throw error
		}
	}

	const editUser = async (userId, user) => {
		try {
			const response = await axios.put(`/users/${userId}`, user)

			return response.data
		} catch (error) {
			console.error("Error updating user:", error)
			throw error
		}
	}

	const deleteUser = async (userId) => {
		try {
			const response = await axios.delete(`/users/${userId}`)

			return response.data
		} catch (error) {
			console.error("Error deleting user:", error)
			throw error
		}
	}

	return {
		getAllUsers,
		createUser,
		editUser,
		deleteUser,
	}
}

export default UsersApi
